export const NAV = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "process", label: "Process" },
  { id: "contact", label: "Contact" },
];

export const OWNER_PHOTO = {
  webp640: "/media/faiz-portrait-640.webp",
  webp1080: "/media/faiz-portrait-1080.webp",
  jpg: "/media/faiz-portrait-1080.jpg",
  width: 1080,
  height: 1350,
  alt: "Faiz, founder of FAIZ",
};

export const CONTACT_EMAIL = "faiz.digitalstudios@gmail.com";

export const HERO = {
  headline: "IDEAS DESERVE A BETTER DIGITAL PRESENCE.",
  supporting:
    "FAIZ creates modern websites and digital experiences that help businesses stand out, connect with customers and grow online.",
};

export const SCENES = [
  { n: "01", label: "THE BUSINESS IDEA", text: "EVERY GREAT BUSINESS STARTS WITH AN IDEA.", hl: [6] },
  { n: "02", label: "THE DIGITAL PRESENCE", text: "WE TURN IDEAS INTO DIGITAL EXPERIENCES.", hl: [5] },
  { n: "03", label: "THE CUSTOMER EXPERIENCE", text: "DESIGNED TO LOOK GOOD. BUILT TO WORK BEAUTIFULLY.", hl: [7] },
  { n: "04", label: "THE RESULT", text: "YOUR NEXT CHAPTER STARTS ONLINE.", hl: [4] },
];

export const ABOUT = {
  heading: "DESIGNING DIGITAL EXPERIENCES THAT MAKE AN IMPRESSION.",
  body: [
    "I'm Faiz, the person behind FAIZ. I focus on creating modern websites and digital experiences that combine thoughtful design, practical functionality and a smooth user experience.",
    "My goal is simple: help businesses establish a strong online presence through websites that look professional, work beautifully and communicate their value.",
  ],
  pillars: ["Thoughtful design", "Practical functionality", "Smooth user experience"],
};

export const PROJECT_TYPES = [
  "Business Website",
  "Landing Page",
  "E-commerce Website",
  "Custom Web Application",
  "Other",
];

export const SERVICES = [
  {
    id: "business-websites",
    title: "BUSINESS WEBSITES",
    desc: "Professional websites that establish credibility and present a business clearly.",
    type: "Business Website",
  },
  {
    id: "landing-pages",
    title: "LANDING PAGES",
    desc: "Focused, attractive landing pages designed to communicate an offer and encourage action.",
    type: "Landing Page",
  },
  {
    id: "e-commerce",
    title: "E-COMMERCE WEBSITES",
    desc: "Modern online shopping experiences with clear product presentation and intuitive navigation.",
    type: "E-commerce Website",
  },
  {
    id: "custom-web-apps",
    title: "CUSTOM WEB APPLICATIONS",
    desc: "Purpose-built web applications designed around specific business requirements.",
    type: "Custom Web Application",
  },
];

export const WHY = [
  "Clean and modern design.",
  "Responsive across devices.",
  "Smooth user experience.",
  "Attention to detail.",
  "Solutions built around business needs.",
];

export const PROCESS = [
  { n: "01", title: "DISCOVER", desc: "Understand the business, goals and requirements." },
  { n: "02", title: "DESIGN", desc: "Plan the layout, visual identity and experience." },
  { n: "03", title: "BUILD", desc: "Develop the website and its functionality." },
  { n: "04", title: "LAUNCH", desc: "Test, refine and prepare the finished website for launch." },
];

export const FINAL = {
  headline: "LET'S BUILD SOMETHING GREAT.",
  supporting: "Have a project in mind? Let's turn your idea into a digital experience.",
};

export const CONTACT = {
  heading: "START A PROJECT",
  intro: "Tell me a little about your project and I'll get back to you.",
};
